import { put, call, takeLatest, select } from 'redux-saga/effects';

import { onlyNumber, formatError } from '../../../libs';
import totemAPI from '../../api/totem';
import { Types, Creators as TotemCreators } from '../../reducers/totem';
import getState from '../../utils/getState';

function* getOrders({ document }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const orders = yield call(totemAPI.getOrders, onlyNumber(document.documento), siteId);

    yield put(TotemCreators.getOrdersSuccess({ orders }));
  } catch (error) {
    yield put(TotemCreators.getOrdersError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_ORDERS_REQUEST, getOrders);
}
